export default {
  unknown: 'Unknown',
  generic_error: 'An error occurred',
};
